require('./OttWidget.scss');

const b = require('app/www/libs/b')('ott-widget');
const bPage = require('app/www/libs/b')('page');

const _ = {
    get: require('lodash/get'),
    pickBy: require('lodash/pickBy'),
};

const React = require('react');
const PropTypes = require('prop-types');
const {stringify} = require('querystring');
const Metrika = require('app/www/libs/client/metrika');

const Global = require('app/www/components/blocks/Global/Global');
const PageVisibilityAware = require('app/www/components/blocks/PageVisibilityAware/PageVisibilityAware');
const Spin = require('app/www/components/blocks/Spin/Spin');

const METRIKA_TIMEOUT = 30 * 1000;

class OttWidget extends React.PureComponent {

    constructor(props) {
        super(props);

        this._onMessage = this._onMessage.bind(this);
        this._stopMetrikaTimeout = this._stopMetrikaTimeout.bind(this);
        this._listenPageVisibility = this._listenPageVisibility.bind(this);
    }

    componentDidMount() {
        this._page = document.querySelector('.page');
        this._pageClass = bPage.mod({'ott-widget': true});
        this._page.classList.add(this._pageClass);

        this._metrikaTimeout = setTimeout(() => Metrika.reachGoal('ONLINE_PLAYER_NOT_BOUNCE'), METRIKA_TIMEOUT);

        window.addEventListener('message', this._onMessage);
    }

    componentWillUnmount() {
        this._stopMetrikaTimeout();
        window.removeEventListener('message', this._onMessage);
    }

    render() {
        const spinProps = {
            mods: {
                size: 'l',
            },
        };

        const iframeAttrs = {
            src: this._src,
            allowFullScreen: true,
        };

        return (
            <div className={b()}>
                <Spin className={b('spin')} {...spinProps} />
                <iframe className={b('iframe')} {...iframeAttrs} />
                <PageVisibilityAware callback={this._listenPageVisibility}/>
            </div>
        );
    }

    /**
     * Формируем source для iframe
     * @returns {string}
     * @private
     */
    get _src() {
        const {
            contentGroupUuid,
            selectionId,
            fromBlock,
        } = this.props;

        const params = _.pickBy({
            filmId: contentGroupUuid,
            selectionId,
            from: Global.id,
            from_block: fromBlock,
        }, Boolean);

        return `${Global.ottWidgetHost}?${stringify(params)}`;
    }

    /**
     * Закрываем плеер
     * Не отправляем метрику
     * @private
     */
    _close() {
        this._page.classList.remove(this._pageClass);
        this._stopMetrikaTimeout();
        this.props.onClose();
    }

    /**
     * Прерываем таймаут отправки метрики
     * @private
     */
    _stopMetrikaTimeout() {
        if (this._metrikaTimeout) {
            clearTimeout(this._metrikaTimeout);
            this._metrikaTimeout = null;
        }
    }

    /**
     * Обработчик сообщений от iframe
     * @param {Object} message
     * @private
     */
    _onMessage(message) {
        if (
            _.get(message, 'origin') === Global.ottWidgetHost &&
            _.get(message, 'data.type') === 'hide'
        ) {
            this._close();
        }
    }

    /**
     * Не отправляем метрику, если вкладка потеряла фокус
     * @param {Boolean} isHidden
     * @private
     */
    _listenPageVisibility(isHidden) {
        if (isHidden) {
            this._stopMetrikaTimeout();
        }
    }

}

OttWidget.defaultProps = {
    onClose: () => {},
};

OttWidget.propTypes = {
    contentGroupUuid: PropTypes.string,
    selectionId: PropTypes.number,
    fromBlock: PropTypes.string,
    onClose: PropTypes.func,
};

module.exports = OttWidget;
